import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCrossRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M2.667 16C2.667 8.636 8.637 2.667 16 2.667S29.333 8.636 29.333 16 23.363 29.333 16 29.333 2.667 23.363 2.667 16m10.04-4.707a1 1 0 0 0-1.414 1.414L14.586 16l-3.293 3.293a1 1 0 1 0 1.414 1.414L16 17.414l3.293 3.293a1 1 0 1 0 1.414-1.414L17.414 16l3.293-3.293a1 1 0 1 0-1.414-1.414L16 14.586z" clipRule="evenodd" /></svg>;
export default SvgIconCrossRoundedFilled;